import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { Brand } from 'app-types/core';

import { BrandInfoGetDefaultQuery } from '../../../gql/core/queries';

export function useDefaultBrand(options?: QueryHookOptions) {
  const { data, loading, error } = useQuery<{ Brand_getDefault: Brand }>(BrandInfoGetDefaultQuery, {
    ...options,
    context: { ...options?.context, clientName: 'core' },
  });

  return {
    data: data?.Brand_getDefault,
    loading,
    error,
  };
}
